import { render, staticRenderFns } from "./health-risk-assessment.vue?vue&type=template&id=6f0b1000&scoped=true"
import script from "./health-risk-assessment.vue?vue&type=script&lang=js"
export * from "./health-risk-assessment.vue?vue&type=script&lang=js"
import style0 from "./health-risk-assessment.vue?vue&type=style&index=0&id=6f0b1000&prod&scoped=true&lang=css"
import style1 from "./health-risk-assessment.vue?vue&type=style&index=1&id=6f0b1000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b1000",
  null
  
)

export default component.exports